/** QA-511 주문번호 다중 검색 — 한 번에 찾는 최대 개수(고도몰과 같음). */
export const ORDER_NO_MULTI_MAX = 10;

export interface OrderNoSearch {
  /** 쉼표·줄바꿈으로 나눈 주문번호(중복 제거, 최대 10개). 나눌 게 없으면 null — 기존 검색어(q)로 찾는다. */
  orderNos: string[] | null;
  /** 10개를 넘겨 뒤쪽을 뺐는지. */
  overflow: boolean;
}

/**
 * 검색어에 쉼표나 줄바꿈이 있으면 주문번호 여러 개로 본다(고도몰 다중 검색: 완전일치, 최대 10개, 넘는 건 버림).
 * 하나만 있으면 null 을 돌려 기존처럼 q(주문번호·주문자·상품명·상품코드 부분일치)로 찾는다.
 */
export const splitOrderNoSearch = (q: string | null | undefined): OrderNoSearch => {
  if (!q || !/[,\r\n]/.test(q)) return { orderNos: null, overflow: false };
  const all = [...new Set(q.split(/[,\r\n]+/).map((s) => s.trim()).filter(Boolean))];
  if (all.length === 0) return { orderNos: null, overflow: false };
  return { orderNos: all.slice(0, ORDER_NO_MULTI_MAX), overflow: all.length > ORDER_NO_MULTI_MAX };
};
